'use client';

import * as React from 'react';
import { useAtomValue } from 'jotai';
import { MAX_POST_PER_PAGE } from '../_server/constants';
import type { PostCardFields } from '../_server/types';
import { defaultSortByAtom } from '../../_components/design-state';
import { PostCard } from './post-card';

export type PostGridProps = {
  posts: PostCardFields[];
};

export function PostGrid({ posts }: PostGridProps): JSX.Element {
  return (
    <ul className="post-list">
      {posts.map((post) => (
        <li className="post-list-item" key={post.id}>
          <PostCard post={post} />
        </li>
      ))}
    </ul>
  );
}

export type DesignPostGridProps = {
  designPosts: PostCardFields[];
};

export function DesignPostGrid({ designPosts }: DesignPostGridProps) {
  const defaultSortBy = useAtomValue(defaultSortByAtom);
  const posts = designPosts.toSorted((a, b) => {
    switch (defaultSortBy) {
      case 'leastRecent':
        return (
          new Date(a.publishedAt).valueOf() - new Date(b.publishedAt).valueOf()
        );
      case 'titleAsc':
        return a.title.localeCompare(b.title);
      case 'titleDesc':
        return b.title.localeCompare(a.title);
      case 'mostRecent':
      default:
        return (
          new Date(b.publishedAt).valueOf() - new Date(a.publishedAt).valueOf()
        );
    }
  });

  return <PostGrid posts={posts.slice(0, MAX_POST_PER_PAGE)} />;
}
